//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPlatformName } from '@/lib/platforms'

export default {
  name: 'CreatePostAccountsMenu',
  props: {
    accountPosts: {
      type: Array,
      default: []
    },
    selectedPostId: {
      type: String,
      default: ''
    }
  },
  methods: {
    getPlatformName,
    handleRemovePost(post) {
      this.$emit('remove-post', post)
    },
    hasPostWithErrors(posts) {
      return posts.some((post) => post.errors.length > 0)
    }
  },
  computed: {
    platformPosts() {
      return this.accountPosts
    }
  }
}
